var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-radio-group',{attrs:{"size":"small"},on:{"change":_vm.onSelectChanged},model:{value:(_vm.dimensionType),callback:function ($$v) {_vm.dimensionType=$$v},expression:"dimensionType"}},[_c('el-radio-button',{attrs:{"label":0}},[_vm._v("单站房多因子")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":1}},[_vm._v("多站房单因子")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34f4d52f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Data/DimensionType.vue
// module id = null
// module chunks = 